import ProductDetailViewNew from './ProductDetailViewNew.jsx';

export default ProductDetailViewNew;


// WEBPACK FOOTER //
// ./src/components/ProductDetailViewNew/index.jsx